
<div class="validate">
  <div
    class="modal-header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.lt-md="start center"
  >
    <h2>{{ "flows.modal.validate.title" | translate: { flow: model.flow_id } }}</h2>
    <div class="close" mat-dialog-close>
      <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
    </div>
  </div>
  <div class="modal-content mob-fixed-button">
    <div class="text-content" fxLayout="column" fxLayoutAlign="start center">
      <div class="icon mb-4" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon class="ic-34 fc-6" aria-hidden="false" aria-label="success" class="success"
          >check_circle</mat-icon
        >
      </div>
      <p class="fs-18 font-color">{{ "flows.modal.validate.success-title" | translate }}</p>
      <span class="fs-14 fc-6">
        {{ "flows.modal.validate.success-desc" | translate }}
      </span>
    </div>
  </div>
  <div class="modal-footer" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="h-medium">
      <a (click)="goSnapshot()" >{{ "flows.modal.validate.after" | translate }}</a>
    </div>
    <button mat-flat-button color="primary" mat-dialog-close (click)="goPublish()">
      {{ "flows.modal.validate.go" | translate }}
    </button>
  </div>
</div>
